<div class="login-box">
    <h1 style="color: #de3a39"> <img src="https://cdn-dev.mastercollections.app/cdn/assets/images/LoginPageImages/MC_Logo_png.png" alt="">Maistering DevOp's</h1>
    <form id="login-form" class="login-form-class" (submit)="loginpage($event)" >
        <!-- <div class="user-box button">
            <input type="text" name="username" required="" [(ngModel)]="login.username">
            <label>Username</label>
        </div>
        <div class="user-box button">
            <input type="password" name="password" required="" [(ngModel)]="login.password">
            <label>Password</label>
        </div> -->
        <div class="button logo">
            
            <input type="submit" class="btn" value="Login">
        </div>
        
    </form>
</div>

